"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SavedViewStyle = _interopRequireDefault(require("./../css/SavedViewStyle"));

var _svgIcons = _interopRequireDefault(require("./../css/svg-icons"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SavedView = function SavedView(_ref) {
  var viewData = _ref.viewData,
      currentSituations = _ref.currentSituations;

  if (currentSituations.length >= 3) {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
      to: "review-answers"
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_SavedViewStyle["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "saved-view"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon",
    dangerouslySetInnerHTML: {
      __html: _svgIcons["default"].checkmark
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: viewData === null || viewData === void 0 ? void 0 : viewData.savedView.savedScenario.html.html
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "overview",
    className: "button"
  }, viewData === null || viewData === void 0 ? void 0 : viewData.savedView.nextButton.html.html), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "review-answers",
    className: "link"
  }, viewData === null || viewData === void 0 ? void 0 : viewData.savedView.answersButton.html.html)));
};

var _default = SavedView;
exports["default"] = _default;